export const endsSession = (status?: number) => status === 401;

export default endsSession;
